import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ProjectPermissionEntryDTO,
  UpdatePermissionOverridesRequest,
  UserProjectPermissionsDTO,
} from '../models/user-project-permissions.model';

@Injectable({ providedIn: 'root' })
export class UserProjectPermissionsService {
  private readonly http = inject(HttpClient);

  list(customerId: string, userId: string): Observable<UserProjectPermissionsDTO> {
    return this.http.get<UserProjectPermissionsDTO>(this.baseUrl(customerId, userId));
  }

  update(
    customerId: string,
    userId: string,
    projectId: string,
    request: UpdatePermissionOverridesRequest,
  ): Observable<ProjectPermissionEntryDTO> {
    return this.http.put<ProjectPermissionEntryDTO>(`${this.baseUrl(customerId, userId)}/${projectId}`, request);
  }

  private baseUrl(customerId: string, userId: string): string {
    return `${environment.apiBaseUrl}/api/v1/customers/${customerId}/users/${userId}/project-permissions`;
  }
}
